var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.58165 14.2664L18.698 4.06073M9.84078 14.7254L11.9079 19.3555C12.4075 20.4744 12.6572 21.0338 12.9719 21.1838C13.245 21.314 13.5571 21.2904 13.8122 21.1204C14.106 20.9245 14.2865 20.3325 14.6475 19.1486L18.5532 6.33877C18.8678 5.30726 19.025 4.7915 18.9173 4.45031C18.8237 4.1535 18.6152 3.92002 18.3502 3.81516C18.0455 3.69462 17.585 3.87073 16.6639 4.22295L5.22556 8.59706C4.16846 9.0013 3.63991 9.20343 3.46495 9.5325C3.3131 9.81807 3.29206 10.1677 3.40831 10.4734C3.54227 10.8258 4.04182 11.1056 5.04092 11.665L9.17524 13.9801C9.3399 14.0723 9.42222 14.1183 9.49347 14.1799C9.55681 14.2346 9.61355 14.2981 9.66229 14.3689C9.71735 14.4488 9.75846 14.541 9.84078 14.7254Z",
    stroke: "url(#paint0_linear_125_1228)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_1228",
    x1: 16.592,
    y1: 2.02745,
    x2: 9.91258,
    y2: 20.8301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSvgrepoCom1);
export default __webpack_public_path__ + "static/media/send-svgrepo-com 1.03cda2f8c9675bee554148ef35b6a73a.svg";
export { ForwardRef as ReactComponent };